import * as React from 'react';

// HORO-10326: chat-history clock glyph per Figma 935:39659 — outer
// circle + two hands. White stroke matches the rest of the menu icons.
const ClockIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <circle cx={10} cy={10} r={7.5} stroke="#FFFFFF" strokeWidth={1.5} />
        <path stroke="#FFFFFF" strokeWidth={1.5} strokeLinecap="round" d="M10 6v4l2.5 2" />
    </svg>
);

export default ClockIcon;
